// extracted by mini-css-extract-plugin
export default {"address":"reportProposedSale_address__8yltJ","modalbody":"reportProposedSale_modalbody__t33Qh"};